import { render, staticRenderFns } from "./documents.revenuedepartment.pp303640.vue?vue&type=template&id=b55fee56&scoped=true"
import script from "./documents.revenuedepartment.pp303640.vue?vue&type=script&lang=js"
export * from "./documents.revenuedepartment.pp303640.vue?vue&type=script&lang=js"
import style0 from "./documents.revenuedepartment.pp303640.vue?vue&type=style&index=0&id=b55fee56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55fee56",
  null
  
)

export default component.exports